/**
 * The secondary text a claim-editor lookup shows after a match's name: " | +1555… | Name@example".
 *
 * A separator is emitted only for a part that has a value. Joining unconditionally left
 * records with a missing phone or email reading "Hien Myking  |  |".
 *
 * Returns `undefined` when nothing is present, which the select option renders as nothing.
 */
export function formatLookupInfo(...parts: Array<string | null | undefined>): string | undefined {
    const present = parts.map(part => (part ?? '').trim()).filter(Boolean);
    return present.length ? ` | ${present.join(' | ')}` : undefined;
}
